import { Intervention } from '@/app/components/action-plan/types';
import ModalInterventionDetails from '../../../modals/details/modal-intervention-details';
import { formatDate } from '../utils/group-by-month';
import { DownArrow } from '@/components/icons/down-arrow';
import { RiskBadge } from '@/components/badges/risk-badge';
import { useState } from 'react';
import ChevronRight from '@/app/components/questionnaireV2/icons/chevron-right';

type CompletedInterventionCardProps = {
  intervention: Intervention;
};

export default function CompletedInterventionCard({ intervention }: CompletedInterventionCardProps) {
  const { copyWhenCompleted, completedAt, overallRiskImpact, isNonQuantifiable } = intervention;
  const [isOpen, setIsOpen] = useState(false);

  const onOpen = () => setIsOpen(true);
  const onClose = () => setIsOpen(false);

  return (
    <div className="completed-intervention-card" onClick={onOpen}>
      <div className="completed-intervention-badge-container">
        {isNonQuantifiable ? (
          <div className="completed-intervention-badge">
            <DownArrow />
          </div>
        ) : (
          <RiskBadge
            value={overallRiskImpact ? parseFloat(Number(overallRiskImpact).toPrecision(1)) : 0}
            variant="success"
            badgeType="change"
            icon={<DownArrow />}
            showPercent={false}
            className="completed-intervention-badge"
          />
        )}      </div>
      <div className="completed-intervention-content">
        <span className="completed-intervention-date">{formatDate(completedAt)}</span>
        <div>
          <span className="completed-intervention-description">
            {copyWhenCompleted}.
          </span>
          <button className="completed-intervention-details-btn" onClick={onOpen}>
            <span>See details</span>
          </button>
        </div>
      </div>
      <div className="completed-intervention-arrow">
        <ChevronRight />
      </div>
      <ModalInterventionDetails isOpen={isOpen} onClose={onClose} intervention={intervention} navToActionPlanHome={false} />
    </div>
  );
}
